<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script >
import { cloudSelect, roldList, imgcommonUrl } from './api/url'
import { postAction } from './api/api'
export default {
  mounted() {
    //加载成果厅轮播页面
    this.loadResult()
  },
  methods: {
    loadResult() {
      let data = {
        action: 'Achievements_BindList',
        TechFieldEnum: '',
        TechnologySource: '',
      }
      postAction(cloudSelect, this.$qs.stringify(data)).then((res) => {
        // // console.log("loadResult获取技术成果", res);
        sessionStorage.setItem('CloudShowresult', JSON.stringify(res))
      })
    },
  },
}
</script>

<style lang="scss">
body {
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
